<div *ngIf="this.aangifte.box1?.uitgavenVoorInkomensvoorzieningen || this.aangifte.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen">
    <form [formGroup]="specLijfrenteFormGroup">
        <div class="row">
            <ng-container formGroupName="specificatieLijfrente">
                <ng-container formGroupName="opbouw">
                    <div *ngIf="specLijfrente.specificatieLijfrente?.opbouw?.aftrekbareLijfrentePremie !== undefined"
                         class="left">
                        <div class="row">
                            <div class="col col-1">
                                <p>Aftrekbare premie lijfrente</p>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2 "></div>
                            <div class="col-2 ps-5">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="aftrekbareLijfrentePremie"
                                        id="aftrekbareLijfrentePremie"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2 "></div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </form>
    <div>
        <form [formGroup]="specLijfrenteFormGroup">
            <div class="row">
                <ng-container formGroupName="specificatieLijfrente">
                    <ng-container formGroupName="opbouw">

                        <div *ngIf="specLijfrente.specificatieLijfrente?.opbouw?.premieAovVerzekering !== undefined"
                             class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Premie arbeidsongeschiktheidsverzekering</p>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2 "></div>
                                <div class="col-2 ps-5">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="premieAovVerzekering"
                                            id="premieAovVerzekering"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2 "></div>
                            </div>
                        </div>
                        <div *ngIf="specLijfrente.specificatieLijfrente?.opbouw?.premieAnwVerzekering !== undefined"
                             class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Premie nabestaandenverzekering</p>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2 "></div>
                                <div class="col-2 ps-5">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="premieAnwVerzekering"
                                            id="premieAnwVerzekering"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2 "></div>
                            </div>
                        </div>
                        <div *ngIf="specLijfrente.specificatieLijfrente?.opbouw?.lijfrenteVoorKind !== undefined"
                             class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Premie verzekering meerderjarig invalide kind(eren)</p>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2 "></div>
                                <div class="col-2 ps-5">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="lijfrenteVoorKind"
                                            id="lijfrenteVoorKind"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2 "></div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </form>

    </div>

    <form [formGroup]="specLijfrenteFormGroup">
        <div class="row">
            <ng-container formGroupName="specificatieLijfrente">
                <ng-container formGroupName="opbouw">
                    <div class="left">
                        <div class="row pt-2">
                            <div class="col col-1">
                                <div *ngIf="!partnerBoolean">
                                    <b>Premies inkomensvoorzieningen {{ this.dataService.naamAangever }}</b>
                                </div>
                                <div *ngIf="partnerBoolean">
                                    <b>Premies inkomensvoorzieningen {{ this.dataService.naamPartner }}</b>
                                </div>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2"></div>
                            <div class="col-2 ps-5">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="saldoPremiesInkomensvoorzieningen"
                                        id="saldoPremiesInkomensvoorzieningen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2 "></div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </form>

    <div *ngIf="this.aangifte.box1?.negatieveUitgavenVoorInkomensvoorzieningen">

        <div class="space20"></div>

        <form [formGroup]="negatievePremieFormGroup">
            <div *ngIf="negatievePremieFormGroup.get('terugontvangenPremieAOV')?.value > 0">
                <div class="row">
                    <div class="col col-1">
                        <p>Terugontvangen premie AOV</p>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-2"></div>
                    <div class="col-2 ps-5">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="terugontvangenPremieAOV"
                                id="terugontvangenPremieAOV"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-2 "></div>
                </div>
            </div>
            <div
                    *ngIf="negatievePremieFormGroup.get('terugontvangenPremieLijfrente')?.value > 0">
                <div class="row">
                    <div class="col col-1">
                        <p>Terugontvangen premie lijfrente</p>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-2"></div>
                    <div class="col-2 ps-5">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="terugontvangenPremieLijfrente"
                                id="terugontvangenPremieLijfrente"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-2 "></div>
                </div>
            </div>
        </form>

        <form *ngIf="this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.saldoNegatievePremiesInkomensvoorzieningen')?.getRawValue() > 0"
              [formGroup]="specLijfrenteFormGroup">
            <div class="row">
                <ng-container formGroupName="specificatieLijfrente">
                    <ng-container formGroupName="opbouw">
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <div *ngIf="!partnerBoolean">
                                        Negatieve premies inkomensvoorzieningen {{ this.dataService.naamAangever }}
                                    </div>
                                    <div *ngIf="partnerBoolean">
                                        Negatieve premies inkomensvoorzieningen {{ this.dataService.naamPartner }}
                                    </div>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2"></div>
                                <div class="col-2 ps-5">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="saldoNegatievePremiesInkomensvoorzieningen"
                                            id="saldoNegatievePremiesInkomensvoorzieningen"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2 "></div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </form>

    </div>


    <div *ngIf="hasWelPremieGeenJaarruimte()">

        <div class="space20"></div>

        Let op: Er is wel een betaalde premie lijfrente ingevuld, maar nog geen gegevens voor het berekenen
        van de jaar- en reserveringsruimtes!

        <div class="space20"></div>
    </div>

    <div *ngIf="hasGeenPremieWelJaarruimte()">

        <div class="space20"></div>

        Let op: Er is geen betaalde premie lijfrente ingevuld, maar wel gegevens voor het berekenen
        van de jaar- en reserveringsruimtes!

        <div class="space20"></div>
    </div>


    <form [formGroup]="specLijfrenteFormGroup">
        <ng-container formGroupName="specificatieLijfrente">
            <ng-container formGroupName="opbouw">
                <ng-container>
                    <p class="pt-3"><b>Jaar- en reserveringsruimte</b></p>

                    <div class="row">
                        <div class="col col-1 pt-3">
                            Jaarruimte {{ this.year }}
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="jaarruimte"
                                    id="jaarruimte"
                                    label="Berekende ruimte"
                                    placeholder="?"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="emptyField"
                                    id="benutteJaarruimte"
                                    label="Reeds eerder benut"
                                    placeholder="-"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="benutteJaarrruimte"
                                    id="benutteJaarruimte"
                                    label="Dit jaar benut"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="resterendeJaarruimte"
                                    id="resterendeJaarruimte"
                                    label="Resteert"
                                    placeholder="-"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2 "></div>
                    </div>
                </ng-container>
                <div *ngIf="hasReserveringsruimte()">
                    <ng-container *ngFor="let jaar of ruimteJaren">
                        <div *ngIf="hasReserveringsruimteVoorJaar(jaar.offset)" class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Reserveringsruimte {{ this.year - jaar.offset }}
                                </div>
                                <div class="col-2 bold">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            [formControlName]="'reserveringsruimte' + jaar.suffix"
                                            align="right"
                                            class="custom-input-150"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2 bold">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            [formControlName]="'alGebruikteRuimte' + jaar.suffix"
                                            align="right"
                                            class="custom-input-150"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            [formControlName]="'benutteReserveringsruimte' + jaar.suffix"
                                            align="right"
                                            class="custom-input-150"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            [formControlName]="'resterendeReserveringsruimte' + jaar.suffix"
                                            align="right"
                                            class="custom-input-150"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-2"></div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="specLijfrente.specificatieLijfrente?.opbouw?.reserveringsruimte !== undefined &&
                                                      specLijfrente?.specificatieLijfrente?.opbouw?.benutteReserveringsruimte !== undefined &&
                                                        specLijfrente.specificatieLijfrente?.opbouw?.reserveringsruimte!.valueOf() <=
                                                        specLijfrente?.specificatieLijfrente?.opbouw?.benutteReserveringsruimte!.valueOf()"
                         class="left">
                        <div class="row">
                            <div class="col col-1">
                                Maximale reserveringsruimte
                            </div>
                            <div class="col col-2"></div>
                            <div class="col col-2"></div>
                            <div class="col col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="reserveringsruimte"
                                        id="Reserveringsruimte"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col col-2"></div>
                            <div class="col-2 "></div>
                        </div>
                    </div>
                    <div *ngIf="specLijfrente?.specificatieLijfrente?.opbouw?.benutteReserveringsruimte !== undefined"
                         class="left">
                        <div class="row pt-2">
                            <div class="col col-1 bold">
                                Totaal
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2 "></div>
                            <div class="col-2 ps-5">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="aftrekbareLijfrentePremie"
                                        id="aftrekbareLijfrentePremie2"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="resterendeTotaleRuimte"
                                        id="resterendeTotaleRuimte"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2 "></div>
                        </div>
                    </div>

                </div>

                <!--                <div class="row">-->
                <!--                    <div class="col col-1">-->
                <!--                        Betaalde premie lijfrente-->
                <!--                    </div>-->
                <!--                    <div class="col-2"></div>-->
                <!--                    <div class="col-2">-->
                <!--                        <snelstart-ui-number-form-control-->
                <!--                                formControlName="betaaldePremiesVoorLijfrente"-->
                <!--                                id="betaaldePremiesVoorLijfrente"-->
                <!--                                class="custom-input-150"-->
                <!--                                [decimals]="0"-->
                <!--                                align="right"-->
                <!--                                prefix="€"-->
                <!--                        ></snelstart-ui-number-form-control>-->
                <!--                    </div>-->
                <!--                    <div class="col-2"></div>-->
                <!--                </div>-->
            </ng-container>

        </ng-container>
    </form>
</div>

<div *ngIf="!this.partnerBoolean && !this.aangifte.box1?.uitgavenVoorInkomensvoorzieningen && !this.aangifte.box1?.negatieveUitgavenVoorInkomensvoorzieningen">
    Er zijn geen premies inkomensvoorzieningen ingevuld bij {{ this.dataService.naamAangever }}.
</div>

<div *ngIf="this.partnerBoolean && !this.aangifte.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen && !this.aangifte.partnerAangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen">
    Er zijn geen premies inkomensvoorzieningen ingevuld bij {{ this.dataService.naamPartner }}.
</div>

